<template>
    <sub-account-link
        v-if="subAccount"
        :uuid="subAccount.uuid"
        class="text-primary"
    >
        {{ subAccount?.name }}
    </sub-account-link>
    <div v-else>...</div>
</template>

<script setup lang="ts">
import {computed, provide} from 'vue'
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'
import {findSubAccountByUuid} from '@/subaccount/subAccount.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params?.context.panelId)
provide('panelPathSegment', props.params?.context.panelPathSegment)

const draftContent = computed(() => props.params?.data?.content)

const subAccount = computed(() => {
    const subAccountUuid = draftContent.value ? draftContent.value.selectedPickedOption?.subAccountUuid : props.params.data.subAccountUuid
    return findSubAccountByUuid(subAccountUuid)
})

</script>

<style scoped>

</style>
